'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './calendar.routes';

export class CalendarComponent {

  constructor($uibModal, $timeout, Auth, $state, VotingsService, SettingsService) {
    'ngInject';

    this.Auth = Auth;
    this.eventSources = [];
    this.$uibModal = $uibModal;
    this.$timeout  = $timeout;

    this.timezone = "America/New_York";

    var eventSourceEvents = {
      events: [],
      color: '#446e9b',
      textColor: 'white'
    };

    var eventSourceDeadlines = {
      events: [],
      color: '#d9534f',
      textColor: 'white'
    };

    var eventSourcePeriods = {
      events: [],
      color: '#228B22',
      textColor: 'white'
    };

    this.eventSources.push(eventSourceEvents);
    this.eventSources.push(eventSourceDeadlines);
    this.eventSources.push(eventSourcePeriods);


    SettingsService.getByName({name: "client"}, settings => {

      this.optInOutHidden = settings.data.optInOut && settings.data.optInOut.hidden;

      console.log(settings, this.optInOutHidden);

      VotingsService.query(data => {

        for (let i = 0; i <= 2; i++) { // cleanup
          if (this.eventSources.length && this.eventSources[i].events.length) {
            this.eventSources[i].events.splice(0, this.eventSources[i].events.length);
          }
        }

        data.forEach(vote => {

          if (vote.state == 'closed')
            return;

          if (vote.state != 'open' && !this.Auth.isAdminSync())
            return;

          //TODO: Show only events that I am allowe to vote

          this.eventSources[0].events.push({
            title: vote.name,
            description: vote.description,
            start: moment(vote.date),
            end: '',
            //allDay: true,
            type: "event"
          });

          if (vote.optInDeadline && !this.optInOutHidden) {
            this.eventSources[1].events.push({
              title: "Opt-In Deadline: " + vote.name,
              description: vote.description,
              start: moment(vote.optInDeadline),
              end: '',
              allDay: true,
              type: "deadline"
            });
          }

          if (vote.optOutDeadline && !this.optInOutHidden) {
            this.eventSources[1].events.push({
              title: "Opt-Out Deadline: " + vote.name,
              description: vote.description,
              start: moment(vote.optOutDeadline),
              end: '',
              allDay: true,
              type: "deadline"
            });
          }

          if (vote.period.from && vote.period.till) {
            this.eventSources[2].events.push({
              title: "Online Voting Open: " + vote.name,
              description: vote.description,
              start: moment(vote.period.from),
              end: moment(vote.period.till),
              allDay: true,
              type: "period"
            });
          }

        });

        this.$timeout(() => {
          jQuery('#fullCalendar').fullCalendar('removeEvents');
          this.eventSources.forEach(eventSource => {
            jQuery('#fullCalendar').fullCalendar('addEventSource', eventSource);
          });
        }, 0);

      });

    });

    var that = this;

    this.uiConfig = {
      calendar: {
        timezone: 'local',
        header: {
          left: 'title',
          center: 'month,agendaWeek,listMonth',
          right: 'today prev,next'
        },
       viewRender: (view, el) => {
         jQuery('#fullCalendar').fullCalendar('removeEvents');
         this.eventSources.forEach(eventSource => {
          jQuery('#fullCalendar').fullCalendar('addEventSource', eventSource);
         })
        },
        eventRender: (event, el) => {

          // Timezone Difference Info
          var timeZoneDiffMin = this.getTimezoneDifference(this.timezone);

          var getTimezoneDiffString = function(mins) {
            var prefix = "+";
            if (mins < 0)
              prefix = "-";

            mins = Math.abs(mins);

            var h = mins / 60 | 0,
                m = mins % 60 | 0;

            if (String(h).length == 1)
              h = "0" + String(h);

            if (String(m).length == 1)
              m = "0" + String(m);

            return prefix + String(h) + ":" + String(m);
          };

          var timeZoneDiffStr = getTimezoneDiffString(timeZoneDiffMin);

          // render the timezone offset below the event title, if
          // user is in other timezone and the event is not all day
          if (!event.allDay && timeZoneDiffMin != 0) {
            el.find('.fc-title').after(
              jQuery('<div class="tzo text-muted"/>').text( timeZoneDiffStr )
            );
          }
        },
        eventClick: (calendarEvent, jsEvent, view) => {

          var that = this;

          /*

          if (calendarEvent.type == 'task') {
            var modalInstance = this.$uibModal.open({
              animation: true,
              component: 'taskShow',
              resolve: {
                config: function () {
                  return {
                    data: calendarEvent.taskData
                  }
                }
              },
              size: 'md'
            });
          } else if (calendarEvent.type == 'workorder') {
            var modalInstance = this.$uibModal.open({
              animation: true,
              component: 'workOrderShow',
              resolve: {
                config: function() {
                  return {
                    workOrder: calendarEvent.workOrderData
                  }
                }
              },
              size: 'md'
            });
          } else if (calendarEvent.type == 'violation') {
            var modalInstance = this.$uibModal.open({
              animation: true,
              component: 'violationShow',
              resolve: {
                config: function() {
                  return {
                    violation: calendarEvent.violationData,
                    level: calendarEvent.levelData,
                    levelDate: calendarEvent.start
                  }
                }
              },
              size: 'md'
            });
          } else {
            var modalInstance = this.$uibModal.open({
              animation: true,
              component: 'calendarEventDetail',
              resolve: {
                calendarEvent: function () {
                  return calendarEvent;
                },
                config: function() {
                  return {
                    userHasPermission: that.Auth.isAdminSync()
                    || (that.Auth.getCurrentUserSync()._id === calendarEvent.meta.creationUser)
                  }
                }
              }
            });

            modalInstance.result.then(
              function (result) {

                if (result.action === 'removed') {
                  that.$timeout(() => {
                    that.getData();
                  },0);
                }

              },
              function () { }
            );
          }

*/

        }
      }
    };
  }

  getTimezoneDifference(targetTimezone, userTimezone) {
    var now = moment();

    if (typeof userTimezone != 'undefined') {
      now = moment.tz(userTimezone);
    }

    var localOffset = now.utcOffset();

    now.tz(targetTimezone);

    var centralOffset = now.utcOffset();
    var diffInMinutes = localOffset - centralOffset;

    return diffInMinutes;
  }

}

export default angular.module('conduuApp.calendar', [uiRouter])
  .config(routes)
  .component('calendar', {
    template: require('./calendar.html'),
    controller: CalendarComponent,
    bindings: {},
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/calendar/calendar.component.js